import React from 'react';
import { useTranslation } from 'react-i18next';
import { FiClock } from 'react-icons/fi';
import { useNavigate } from 'react-router-dom';
import { useAppSelector } from '../../hooks/hooksRedux';
import { RootState } from '../../store';
import { defaultColors } from '../../styles/style-guide';
import { SecondaryCustomButton } from '../../components/Buttons';

interface ComingSoonScreenProps {
  /** Translation key for the feature name (e.g. 'others.othScheduleSpecialist') */
  titleKey?: string;
}

/**
 * Full-page "Coming soon" screen shown in the main content area.
 * Use for features that are not yet available (e.g. Agendar Especialista).
 */
const ComingSoonScreen: React.FC<ComingSoonScreenProps> = ({ titleKey = 'validations.valStayTuned' }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { colors } = useAppSelector((state: RootState) => state.styleGuide.data);
  const primaryColor = colors?.primary || defaultColors.primary;

  return (
    <div className="flex min-h-[60vh] flex-col items-center justify-center px-4 py-12">
      <div
        className="flex max-w-md flex-col items-center rounded-2xl border border-gray-200 bg-white p-10 text-center shadow-lg"
        style={{ borderTopColor: primaryColor, borderTopWidth: 4 }}
      >
        <div
          className="mb-6 flex h-20 w-20 items-center justify-center rounded-full"
          style={{ backgroundColor: `${primaryColor}18` }}
        >
          <FiClock size={40} style={{ color: primaryColor }} />
        </div>
        <h1 className="text-2xl font-bold text-gray-800">
          {titleKey ? t(titleKey) : t('validations.valStayTuned')}
        </h1>
        <p className="mt-3 text-gray-600">{t('validations.valStayTuned')}</p>
        <SecondaryCustomButton text={t('buttons.btnBack')} onClick={() => navigate(-1)} className="mt-8" />
      </div>
    </div>
  );
};

export { ComingSoonScreen };
